import React from 'react'
import GlobalStyles from './GlobalStyles'
import styled from '@emotion/styled'

import mq from '../styles/mediaQueries'

const OuterWrapper = styled.div`
  ${mq({
    display: 'flex',
    justifyContent: 'center',
    margin: ['0', '0', '0 12px 0 72px', '0 12px 0 72px', '0 12px 0 72px'],
  })};
`

const InnerWrapper = styled.div`
  ${mq({
    display: 'grid',
    flex: 1,
    gridTemplateColumns: [
      'repeat(4, 1fr)',
      'repeat(8, 1fr)',
      'repeat(12, 1fr)',
      'repeat(12, 1fr)',
      'repeat(12, 1fr)',
    ],
    margin: ['0 20px', '0 36px', '0 36px', '0 60px', '0 60px'],
    columnGap: ['20px', '24px', '36px', '40px', '48px'],
    maxWidth: ['unset', 'unset', 'unset', '1560px', '1560px'],
  })};
`

class Layout extends React.Component {
  render() {
    const { children } = this.props

    return (
      <React.Fragment>
        <GlobalStyles />
        <OuterWrapper>
          <InnerWrapper>{children}</InnerWrapper>
        </OuterWrapper>
      </React.Fragment>
    )
  }
}

export default Layout
